import React, { useEffect } from 'react';

import AssignExam from './ExamSection/Exam';
import Accordion from './Accordion';
import TrainingExam from './TrainingSection/Training';
import ExamTest from './MockSection/Mock';
import './Dashboard.css';
// import NotificationBanner from '../../../components/NotificationBanner/NotificationBanner';

const Dashboard = () => {
  useEffect(() => {
    document.title = 'Dashboard - Finhaat Gurukul';
  }, []);

  return (
    <>
    {/* <NotificationBanner /> */}
      <TrainingExam />
      <ExamTest />
      <AssignExam />

      {/* <Accordion /> */}
    </>
  );
};

export default Dashboard;
